import { MenuItem } from './menu.model';


export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Dashboard',
        icon: 'bx-home-circle',
        link: '/dashboard',
        subItems: [
            {
                id: 1,
                parentId: 1,
                label: 'Analytics',
                link: '/dashboard'
            },
            {
                id: 2,
                parentId: 1,
                label: 'Overview',
                link: '/dashboard/overview'
            },
            {
                id: 3,
                parentId: 1,
                label: 'Notification Monitoring',
                link: '/dashboard/notification-monitoring'
            }
        ]
    },
    {
        id: 2,
        label: 'Banner',
        icon: 'bx-briefcase-alt',
        link: '/banner'
    },
    {
        id: 3,
        label: 'Quiz',
        icon: 'bx-store',
        subItems: [
            {
              id: 7,
              parentId: 3,
              label: 'Common Quiz',
              link: '/quiz/common-quiz'
            },
            {
                id: 4,
                parentId: 3,
                label: 'Add',
                link: '/quiz/add'
            },
            {
                id: 5,
                parentId: 3,
                label: 'List',
                link: '/quiz/list'
            },
            {
                id: 6,
                parentId: 3,
                label: 'Results',
                link: '/quiz/results'
            }
        ]
    },
    {
        id: 4,
        label: 'AI Insight',
        icon: 'bx-bulb',
        subItems: [
            {
                id: 1,
                parentId: 4,
                label: 'Match Insights',
                link: '/ai-insight/match-insights'
            }
        ]
    },
    {
        id: 5,
        label: 'Settings',
        icon: 'bx-cog',
        subItems: [
            {
                id: 1,
                parentId: 5,
                label: 'Manual Sync',
                link: '/settings/manual-sync'
            },
            {
                id: 2,
                parentId: 5,
                label: 'Configure Updates',
                link: '/settings/app-version'
            },
            {
                id: 3,
                parentId: 5,
                label: 'Ads Configuration',
                link: '/settings/ads-config'
            },
            {
                id: 4,
                parentId: 5,
                label: 'LLM Settings',
                link: '/settings/llm-settings'
            }
        ]
    },
]
